
document.addEventListener("DOMContentLoaded", function () {
  const discountCode = gapGetCollectionCookie("_gap_discount");
  const discountMap = {
    "SAVE15": 15,
    "THANKYOU20": 20,
    "WELCOME15": 15,
    "SOLO25": 25,
    "TAKE15OFF": 15,
    "SAVE20": 20,
    "GYPSY20": 20,
    "DANKE20": 20,
    "MERCI20": 20,
    "GRAZIE20": 20,
    "GRACIAS20": 20,
    "GAPSAVE15": 15,
    "SHARON20": 20,
    "BEDANKT20": 20,
    "TACK20": 20,
    "EWTHANKS20": 20
  };

  if (!discountCode || !(discountCode.toUpperCase() in discountMap)) {
    console.log("🚫 No valid discount code for collection page");
    return;
  }

  const discountPercent = discountMap[discountCode.toUpperCase()];
  const discountRate = discountPercent / 100;

  const lang = document.body.dataset.lang || "en";
  const messages = {
    en: `🎉 ${discountCode.toUpperCase()}`,
    de: `🎉 ${discountCode.toUpperCase()}`,
    fr: `🎉 ${discountCode.toUpperCase()}`,
    es: `🎉 ${discountCode.toUpperCase()}`,
    it: `🎉 ${discountCode.toUpperCase()}`,
    nl: `🎉 ${discountCode.toUpperCase()}`,
    sv: `🎉 ${discountCode.toUpperCase()}`
  };
  const messageText = messages[lang] || messages["en"];

  const cartCurrency = gapGetCollectionCookie("cart_currency") || "USD";

  document.querySelectorAll(".grid-product__price").forEach(function (priceContainer) {
    if (priceContainer.classList.contains("gap-collection-price")) return;

    let rawText = "";
    const moneyEl = priceContainer.querySelector(".money");
    if (moneyEl) {
      rawText = moneyEl.textContent.trim();
    } else {
      rawText = priceContainer.textContent.trim();
    }

    const originalPrice = gapParseCollectionPrice(rawText, cartCurrency);
    if (originalPrice === null) return;

    const discountedPrice = originalPrice * (1 - discountRate);
    const formattedOriginal = gapFormatCollectionPrice(originalPrice, cartCurrency);
    const formattedDiscount = gapFormatCollectionPrice(discountedPrice, cartCurrency);

    priceContainer.innerHTML = `
      <span style="text-decoration: line-through; color: gray;">${formattedOriginal}</span>
      <span style="color: green; font-weight: bold;">${formattedDiscount}</span><br>
      <span class="bh-grid-discount" style="color: green;">${messageText}</span>
    `;
    priceContainer.classList.add("gap-collection-price");
  });

  function gapParseCollectionPrice(text, currency) {
    let numberMatch = text.match(/\d+[\.,]?\d*/);
    if (!numberMatch) return null;

    let price = numberMatch[0].replace(",", ".");
    return parseFloat(price);
  }

  function gapFormatCollectionPrice(amount, currency) {
    amount = parseFloat(amount);
    switch (currency) {
      case "USD":
      case "CAD":
      case "AUD":
        return `$${amount.toFixed(2)}`;
      case "GBP":
        return `£${amount.toFixed(2)}`;
      case "EUR":
        return `€${amount.toFixed(2).replace(".", ",")}`;
      case "SEK":
        return `${amount.toFixed(2).replace(".", ",")} kr`;
      default:
        return amount.toFixed(2);
    }
  }

  function gapGetCollectionCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
    }
    return null;
  }
});
